import moment from 'moment-timezone'

export default class LeavePermission {
  static canCancel(leave, employment) {
    if (this.isLeaveCancelledOrRejected(leave)) {
      return false
    }

    if (leave.cancellation) {
      return leave.cancellation.canCancel
    }

    // Fallback when cancellation data is not available
    if (employment.isAdmin()) {
      return true
    }

    if (leave.status === 'REQUESTED' && this.canApprove(leave, employment)) {
      return true
    }

    if (leave.type.only_admin) {
      return false
    }

    return (
      this.canApprove(leave, employment) ||
      (employment.id === leave.owner_id && this.isFuture(leave))
    )
  }

  static canApprove(leave, employment) {
    return this._ownerSubordinateOf(employment, leave.owner_id)
  }

  static canEditLeave(leave, employment) {
    if (employment.is_admin) {
      return true
    }

    if (leave.type.only_admin) {
      return false
    }

    return (
      this._ownerSubordinateOf(employment, leave.owner_id) ||
      (employment.id === leave.owner_id && this.isFuture(leave))
    )
  }

  static canAddAttachments(leave, viewer) {
    return (
      viewer.is_admin ||
      this._ownerSubordinateOf(viewer, leave.owner_id) ||
      viewer.id === leave.owner_id
    )
  }

  static canRetract(leave, employment) {
    return this.isApproverOrAdmin(leave, employment)
  }

  static isApproverOrAdmin(leave, employment) {
    return this.canApprove(leave, employment) || employment.is_admin
  }

  static canAddComment(leave, commenter) {
    return (
      this.isApproverOrAdmin(leave, commenter) ||
      commenter.id === leave.owner_id ||
      commenter.isFollowerOf(leave.owner.getKey())
    )
  }

  static isFuture(leave) {
    const leaveDate = moment(leave.from)
      .tz(leave.timezone)
      .startOf('day')
    const currentTime = moment()
      .tz(leave.timezone)
      .startOf('day')
    return leaveDate.isAfter(currentTime)
  }

  static isLeaveCancelledOrRejected(leave) {
    return ['CANCELLED', 'REJECTED'].includes(leave.status)
  }

  static _ownerSubordinateOf(employment, ownerKey) {
    return (
      !!employment.subordinates &&
      employment.subordinates.some(employment => employment.id === ownerKey)
    )
  }
}
